function formatNumber(value) {
    return Number(value || 0).toLocaleString("de-DE", {
        maximumFractionDigits: 0,
        minimumFractionDigits: 0,
    });
}

function updateCalculator(card) {
    const inputs = Array.from(card.querySelectorAll("[data-calc-input]"));
    const resultNumber = card.querySelector("[data-calc-result-number]");
    const resultSuffix = card.querySelector("[data-calc-result-suffix]");
    let product = inputs.length > 0 ? 1 : 0;

    inputs.forEach((input) => {
        const field = input.closest(".calculator__field");
        const display = field ? field.querySelector("[data-calc-display]") : null;
        const value = Math.round(Number(input.value || 0));
        const unit = input.dataset.unit || "";

        if (display) {
            display.textContent = formatNumber(value);
            const existingUnit = display.nextElementSibling;
            if (existingUnit && existingUnit.classList.contains("unit")) {
                existingUnit.textContent = unit;
                existingUnit.style.display = unit ? "" : "none";
            }
        }

        product *= value;
    });

    if (resultNumber) {
        resultNumber.textContent = formatNumber(Math.round(product));
    }

    if (resultSuffix) {
        resultSuffix.style.display = resultSuffix.textContent.trim() ? "" : "none";
    }
}

document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll("[data-umsatz-calculator]").forEach((card) => {
        updateCalculator(card);

        card.querySelectorAll("[data-calc-input]").forEach((input) => {
            input.addEventListener("input", () => updateCalculator(card));
            input.addEventListener("change", () => updateCalculator(card));
        });
    });
});
